module.exports = __webpack_public_path__ + "static/media/thumb.af9a7f3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/sussex-street-mixed-use/thumb.jpg
// module id = 48
// module chunks = 0